import React from "react";
import { Route, RouteProps } from "react-router";
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from '../../config';


const MsalAuthRoute: React.FC<RouteProps> = (props) => (
    <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={loginRequest}
        errorComponent={({ error }) => <p>An Error Occurred: {error?.message}</p>}
        loadingComponent={() => <p>Authentication in progress...</p>}
    >
        <Route {...props} />
    </MsalAuthenticationTemplate>
)


export default MsalAuthRoute;

